import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Axios from "../../axiosInstance";
import { policyApiEndpoints } from "../../../api";

const initialState = {
  paymentLink: "",
  isLoading: false,
  success: null,
  error: null,
};


export const policyPay = createAsyncThunk(
    "policyPay",
    async (payload, { rejectWithValue }) => {
        try {
            console.log("Calling policyPay...")
            const response = await Axios.post(`${policyApiEndpoints.pay}`, payload);
            console.log("policyPay response is: ", response.data)

            return response.data;
        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
);

export const policyPayAddCovers = createAsyncThunk(
  "policyPayAddCovers",
  async (payload, { rejectWithValue }) => {
      try {
          console.log("Calling policyPay with Add Covers...")
          const response = await Axios.post(`${policyApiEndpoints.payAddCovers}`, payload);
          console.log("policyPay Add Covers response is: ", response.data)

          return response.data;
      } catch (err) {
          return rejectWithValue(err.response.data);
      }
  }
);

export const policyPayTransferFees = createAsyncThunk(
  "policyPayTransferFees",
  async (payload, { rejectWithValue }) => {
      try {
          console.log("Calling policyPayTransferFees...")
          const response = await Axios.post(`${policyApiEndpoints.payTransferFees}`, payload);
          console.log("policyPayTransferFees response is: ", response.data)

          return response.data;
      } catch (err) {
          return rejectWithValue(err.response.data);
      }
  }
);

export const policyPayAdjustSumInsured = createAsyncThunk(
  "policyPayAdjustSumInsured",
  async (payload, { rejectWithValue }) => {
      try {
          console.log("Calling payAdjustSumInsuredFees...")
          const response = await Axios.post(`${policyApiEndpoints.payAdjustSumInsuredFees}`, payload);
          console.log("payAdjustSumInsuredFees response is: ", response.data)

          return response.data;
      } catch (err) {
          return rejectWithValue(err.response.data);
      }
  }
);

export const policyPaySlice = createSlice({
  name: "policyPaySlice",
  initialState,
  reducers: {
    clearPolicyPayError: (state) => {
      state.error = null;
    },
    clearPolicyPayState: () => initialState
  },
  extraReducers: (builder) => {
    // Policy Pay API
    builder.addCase(policyPay.pending, (state, action) => {
      if (!state.data) {
        state.isLoading = true;
      }
    });
    builder.addCase(policyPay.fulfilled, (state, action) => {
      state.isLoading = false;
      state.paymentLink = action?.payload;
    });
    builder.addCase(policyPay.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error?.message;
    });  

    // Policy Pay Transfer API
    builder.addCase(policyPayTransferFees.pending, (state, action) => {
      if (!state.data) {
        state.isLoading = true;
      }
    });
    builder.addCase(policyPayTransferFees.fulfilled, (state, action) => {
      state.isLoading = false;
      state.paymentLink = action?.payload;
    });
    builder.addCase(policyPayTransferFees.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error?.message;
    });  

    // Policy Pay Add Covers
    builder.addCase(policyPayAddCovers.pending, (state, action) => {
      if (!state.data) {
        state.isLoading = true;
      }
    });
    builder.addCase(policyPayAddCovers.fulfilled, (state, action) => {
      state.isLoading = false;
      state.paymentLink = action?.payload;
    });
    builder.addCase(policyPayAddCovers.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error?.message;
    });  

    // Policy Pay Adjust Sum Insured
    builder.addCase(policyPayAdjustSumInsured.pending, (state, action) => {
      if (!state.data) {
        state.isLoading = true;
      }
    });
    builder.addCase(policyPayAdjustSumInsured.fulfilled, (state, action) => {
      state.isLoading = false;
      state.paymentLink = action?.payload;
    });
    builder.addCase(policyPayAdjustSumInsured.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error?.message;
    });
  },
});

// SELECTORS
export const getPaymentLink = (store) => store?.policyPay.paymentLink;
export const getPolicyPayLoading = (store) => store?.policyPay.isLoading;
export const getPolicyPaySuccess = (store) => store?.policyPay.success;

// export const getTransferPolicyPayLoading = (store) => store?.policyPayTransferFees.isLoading;
// export const getTransgerPolicyPaySuccess = (store) => store?.policyPayTransferFees.success;

export const getAddCoversPolicyPayLoading = (store) => store?.policyPay.isLoading;
export const getAddCoversPolicyPaySuccess = (store) => store?.policyPayAddCovers.success;


// export const getSumInsuredLoader = (store) => store?.getSumInsured.isLoading;


// ACTIONS TO DISPATCH
export const { clearPolicyPayError, clearPolicyPayState} = policyPaySlice.actions;

export default policyPaySlice.reducer;
